export default __webpack_public_path__ + "locales/bg/ChangePasswordDialog.json?hash=a9e2c4ae0ae928963d5c2b398680cbb7";